export function validateColor(color) {
  return /^#[0-9a-f]{6}$/gi.test(color);
}

export function validateText(inputValue) {
  return inputValue && inputValue.length > 0;
}

export function validateUrl(url) {
  return /^(?:(http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}/gi.test(url) || /^\/.*/gi.test(url);
}

export function validateEmail(email) {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/i.test(email);
}

export function validateButtonWidth(width) {
  if (typeof width === "undefined" || width === null || width.length === 0) {
    return true;
  }

  const parsedWidth = parseFloat(width);
  return !isNaN(parsedWidth) && parsedWidth > 0 && parsedWidth <= 100;
}
